import ParanormalUnexplained from './ParanormalUnexplained'

export default ParanormalUnexplained
// eslint-disable-next-line import/export
export * from './ParanormalUnexplained'
